import useDidUpdate from '@/hooks/useDidUpdate';

const useHighlightsSliderSync = ({sliderRef, currentIndex}) => {
    useDidUpdate(() => {
        sliderRef.current.slickGoTo(currentIndex);
    }, [currentIndex]);
};

export default useHighlightsSliderSync;
